import React from 'react';
import '@cb/apricot/CBBase';
export const verticalSpacings = ['0', '8', '16', '24', '32', '48', '72'];
export const Spacer = ({ size }) => size === '0' ? null : React.createElement("div", { className: size ? `cb-spacerv-${size}` : 'cb-spacerv' });
export const SpacerV = ({ size }) => size === '0' ? null : React.createElement("div", { className: size ? `cb-spacerv-${size}` : 'cb-spacerv' });
export const horizontalSpacings = ['0', '4', '8', '16', '24', '32', '72'];
export const SpacerH = ({ size }) => React.createElement("div", { className: size ? `cb-spacerh-${size}` : 'cb-spacerh' });
//# sourceMappingURL=Spacer.js.map